<template>
  <article class="ren-decoration-cp ren-decoration-cp-cms-article-detail">
    <strong v-if="showTitle">{{ title }}</strong>
    <span v-if="showSummary && summary">{{ summary }}</span>
    <p>{{ plainText }}</p>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, previewDataRecord, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const showTitle = computed(() => booleanValue(props.component.props?.showTitle, true))
const showSummary = computed(() => booleanValue(props.component.props?.showSummary, true))
const title = computed(() => stringValue(data.value.title, '图文详情'))
const summary = computed(() => stringValue(data.value.summary))
const plainText = computed(() =>
  stringValue(data.value.html ?? data.value.content, '暂无正文')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)
</script>

<style scoped>
.ren-decoration-cp-cms-article-detail {
  display: grid;
  gap: 8px;
}
.ren-decoration-cp-cms-article-detail span,
.ren-decoration-cp-cms-article-detail p {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
}
</style>
